module.exports = __webpack_public_path__ + "static/media/galano-grotesque-alt-bold.db7e9199.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/galano-grotesque-alt-bold.woff
// module id = 1029
// module chunks = 0